/**
 * Modalita' sviluppatore, locale al dispositivo.
 *
 * Si accende toccando dieci volte il copyright nel footer (vedi LegalFooter.tsx)
 * e si spegne con altri dieci. Rivela la versione dell'app e la scheda «Streak»
 * della classifica. Vive qui — non nello stato di un componente — perche' e' una
 * proprieta' del DISPOSITIVO, non di una schermata: deve sopravvivere a un reload.
 *
 * Il TEMA della cornice stava dietro questo stesso segreto, e il 12 ottobre 2026
 * ne e' uscito: chiaro e scuro sono di tutti, e lo script pre-disegno di
 * `index.html` — che per quello chiedeva anche questa chiave, riscritta la' a
 * mano — ora guarda la sola chiave specchio del tema.
 *
 * Deliberatamente slegata dal gate `import.meta.env.DEV || VITE_SHOW_DEV_FEATURES`
 * (vedi EditorScreen.tsx): quello e' un letterale di build il cui scopo e' far
 * cadere codice dal bundle di produzione, questo e' un interruttore a runtime,
 * quindi non puo' gattare un confine di code-splitting.
 *
 * Ogni accesso a localStorage sta DENTRO una funzione, mai a livello di modulo:
 * cosi' il modulo si importa senza esplodere anche fuori dal browser (in Node
 * `localStorage` non esiste e il ReferenceError finisce nel try/catch).
 */

export const DEVELOPER_MODE_KEY = 'draughts-developer-mode';

/** Tutto cio' che non e' esattamente 'true' — assente, spazzatura, storage negato — e' spento. */
export function getStoredDeveloperMode(): boolean {
  try {
    return localStorage.getItem(DEVELOPER_MODE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setStoredDeveloperMode(on: boolean): void {
  try {
    if (on) {
      localStorage.setItem(DEVELOPER_MODE_KEY, 'true');
    } else {
      // Si rimuove invece di scrivere 'false': spento e' il default, e una chiave
      // assente non lascia traccia su chi il segreto non l'ha mai trovato.
      localStorage.removeItem(DEVELOPER_MODE_KEY);
    }
  } catch {
    // Modalita' privata / storage disabilitato: il flag dura solo questa sessione.
  }
}
